import React from "react";

const Sidebar = ({ householdData, onViewDocuments }) => {
  if (!householdData) {
    return null;
  }

  const advisorName = householdData.advisor_details 
    ? `${householdData.advisor_details.first_name || ''} ${householdData.advisor_details.last_name || ''}`.trim()
    : '';
  
  const completionPercentage = householdData.completion_percentage
    ? Math.floor(householdData.completion_percentage)
    : null;

  // Get client email from primary member's personal_info
  const getClientEmail = () => {
    const members = householdData.household_members || householdData.members || [];
    const primaryMember = members.find(member => member.is_primary === true);
    
    if (!primaryMember || !primaryMember.personal_info) {
      return '';
    }
    
    let personalInfo = primaryMember.personal_info;
    if (typeof personalInfo === 'string') {
      try {
        personalInfo = JSON.parse(personalInfo);
      } catch {
        return '';
      }
    }
    
    return personalInfo.email || '';
  };
  
  const clientEmail = getClientEmail();

  return (
    <div className="h-full p-6 flex flex-col">
      {/* Household Name */}
      <div className="mb-6">
        <h2 className="text-xl font-bold text-gray-900">{householdData.name}</h2>
      </div>

      {/* Completion Percentage Bar */}
      {completionPercentage !== null && (
        <div className="mb-6">
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium text-gray-700">Completion</span>
            <span className="text-sm font-bold text-emerald-600">{completionPercentage}%</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-3">
            <div
              className="bg-emerald-600 h-3 rounded-full transition-all duration-300"
              style={{ width: `${completionPercentage}%` }}
            ></div>
          </div>
        </div>
      )}

      {/* Advisor Name */}
      {advisorName && (
        <div className="mb-6">
          <div className="text-sm font-medium text-gray-600 mb-1">Advisor</div>
          <div className="text-base font-semibold text-gray-900">{advisorName}</div>
        </div>
      )}

      {/* User Email */}
      {clientEmail && (
        <div className="mb-6">
          <div className="text-sm font-medium text-gray-600 mb-1">Email</div>
          <div className="text-base font-semibold text-gray-900 break-words">{clientEmail}</div>
        </div>
      )}

      {/* Document Folder Button - Positioned directly after Email */}
      <div className="mb-6">
        <button
          onClick={onViewDocuments}
          className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-emerald-50 text-emerald-700 rounded-xl font-semibold text-sm hover:bg-emerald-100 transition-colors duration-200 border border-emerald-200"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
          Document Folder
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
